import { render, staticRenderFns } from "./chooseFlashSaleGoods.vue?vue&type=template&id=61071e19&"
import script from "./chooseFlashSaleGoods.vue?vue&type=script&lang=js&"
export * from "./chooseFlashSaleGoods.vue?vue&type=script&lang=js&"
import style0 from "./chooseFlashSaleGoods.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports